import { cva } from "../../styled-system/css";

export const button = cva({
  base: {
    backgroundColor: 'surface.primary',
    borderColor: 'border.secondary',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.03)',
    height: '36px',
    px: '12px',
    width: 'fit-content',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    whiteSpace: 'nowrap',
    position: 'relative',
    _disabled: {
      backgroundColor: 'surface.disable',
      borderColor: 'border.secondary',
      color: 'text.disable',
      cursor: 'not-allowed',
      boxShadow: 'none',
    }
  },
  variants: {
    color: {
      primary: {
        backgroundColor: 'surface.accentPrimary',
        borderColor: 'border.accentPrimary',
        color: 'text.inverse',
      },
      secondary: {
        backgroundColor: 'surface.accentSecondary',
        borderColor: 'border.accentSecondary',
      },
      ghost: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: 'text.primary',
        boxShadow: 'none',
        _hover: {
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
        },
        _disabled: {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: 'text.disable',
          boxShadow: 'none',
          _hover: {
            backgroundColor: 'transparent',
          }
        }
      }
    },
    size: {
      icon: {
        width: '36px',
        height: '36px',
        padding: '0',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }
  }
});
